module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tw-a72a85cb06aca393b4c6820552923106.svg";